import { Grid } from 'antd'
import Button from 'app/components/UI-Elements/General/Button'
import HomePageButton from 'app/components/UI-Elements/General/HomePageButton'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { useCurrentCustomer } from 'app/lib/hooks/useCurrent'
import { useRestriction } from 'app/lib/hooks/useRestriction'
import CapacitorService from 'app/lib/services/CapacitorService'
import { Routes } from 'app/routes/Routes'
import React from 'react'
import { useNavigate } from 'react-router-dom'

type Props = {
  rentalId: number | string
}

const RentalRedirectionButton: React.FC<Props> = ({ rentalId }) => {
  const { tComponent } = ToolBox.useString()
  const { buttonId } = ToolBox.useId()
  const navigate = useNavigate()
  const { has_klarx_manager_access } = useCurrentCustomer()
  const { restricted } = useRestriction({ allowFor: ['admin', 'manager', 'member', 'accounting'] })
  const { md } = Grid.useBreakpoint()
  const getId = (action: string) => buttonId({ recordType: RecordType.rental, action })

  const goToRental = () => {
    navigate(Routes.Rental.member(String(rentalId)).show)
  }

  const translate = (id: string) =>
    tComponent({
      componentType: 'core',
      componentName: 'redirection',
      recordType: RecordType.rental,
      id
    })

  return (
    <Choose>
      <When condition={(restricted || !has_klarx_manager_access) && CapacitorService.isWeb()}>
        <HomePageButton id={getId('go_to_website')} />
      </When>
      <Otherwise>
        <If condition={!md}>
          <Button
            onClick={goToRental}
            type={'primary'}
            title={translate('to_rental')}
            id={getId('to_rental')}
          />
        </If>
      </Otherwise>
    </Choose>
  )
}

export default RentalRedirectionButton
